// Copyright 2023 Sorama B.V.
import { IWorkflowPropertyParser } from "libraries/WorkflowFramework/Interfaces/IWorkflowPropertyParser";
import { SelectableRange } from "services/FrequencySelection/FrequencySelectionService";

export class SelectableRangeParser implements IWorkflowPropertyParser<SelectableRange> {
    toWorkflowProperty(object: SelectableRange): string {
        if (object == undefined || object.from == undefined || object.to == undefined) {
            return "";
        }

        return object.from.toFixed(2) + "," + object.to.toFixed(2) + "," + (object.isSelected ? "1" : "0");
    }

    fromWorkflowProperty(str: string): SelectableRange {
        const vals = str.split(",");
        return <SelectableRange>{
            from: Number(vals[0]),
            to: Number(vals[1]),
            isSelected: vals.length > 2 && vals[2] == "1" ? true : false,
        };
    }
}
